export function translateStatusToErrorMessage(status: number,message:string) {
    switch (status) {
      case 401:
        return `Status Code : 401 , Message : Please login again.${message}`;
      case 403:
        return `Status Code : 403, Message : Forbidden Error.${message}`;
        case 404:
          return `Status Code : 404, Message : The requested resource could not be found.${message}`;
      case 500:
        return `Status Code : 500, Message : Internal Server Error.${message}`;
        case 400:
          return `Status Code : 400, Message : Bad Request.${message}`;
      default:
        return `There was an error retrieving the project(s). Please try again.${message}`;
    }
  }
 export async function checkStatus(response: any) {
    if (response.ok) {
      return response;
    } else {
      let errorMessage = '';
      try {
        const errorResponse = await response.json();
        errorMessage = errorResponse.message || JSON.stringify(errorResponse);
      } catch (e) {
        errorMessage = response.statusText;
      }
      const httpErrorInfo = {
        status: response.status,
        statusText: response.statusText,
        url: response.url,
        message:errorMessage
      };
      console.log(`log server http error: ${JSON.stringify(httpErrorInfo)}`);
  
      let formattedErrorMessage  = translateStatusToErrorMessage(httpErrorInfo.status,httpErrorInfo.message);
      throw new Error(formattedErrorMessage );
    }
  }
  
 export function parseJSON(response: Response) {
  if(response.status!=204){
    console.log("response", response);
    return response.json();
  }
  else
  {
    return [];
  }
}